<template>
    <div v-if="themesEnabled" class="vrm-theme-background vrm-theme-background--login no-padding">
        <template v-if="isChristmasThemeEnabled">
            <vrm-christmas-animation />
        </template>
        <template v-else-if="isSummerThemeEnabled && isLightMode">
            <vrm-summer-login-animation />
        </template>
        <template v-else-if="isEasterThemeEnabled">
            <div class="vrm-theme-background__image">
                <img
                    class="mobile-only"
                    src="/img/themes/easter/background-login-mobile.svg"
                    alt="Easter illustration background"
                />

                <img
                    class="desktop-only"
                    src="/img/themes/easter/background-login-desktop.svg"
                    alt="Easter illustration background"
                />
            </div>
        </template>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import ClassWatcher from '@/vue/components/shared/anim/class-watcher';
import VrmChristmasAnimation from '@/vue/components/shared/anim/christmas/VrmChristmasAnimation.vue';
import VrmSummerLoginAnimation from '@/vue/components/shared/anim/summer/VrmSummerLoginAnimation.vue';

@Component({
    components: {
        VrmChristmasAnimation,
        VrmSummerLoginAnimation,
    },
})
@AngularDirective('vrm-theme-login-background')
export default class VrmThemeLoginBackground extends Vue {
    @ngInject()
    AppearanceService;

    isLightMode = null;

    watcher = null;

    created() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    mounted() {
        if (this.themesEnabled != null) {
            // Only listen for dark mode changes if there is an active theme at the moment.
            this.watcher = new ClassWatcher(
                document.documentElement,
                'dark',
                this.onModeChanged,
                this.onModeChanged,
            );

            this.isLightMode = !document.documentElement.classList.contains('dark');
        }
    }

    onModeChanged() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    get summerAnimationsEnabled() {
        return this.AppearanceService.isSummerThemeAnimationsActive();
    }

    get isChristmasThemeEnabled() {
        return this.AppearanceService.isChristmasThemeActive();
    }

    get isSummerThemeEnabled() {
        return this.AppearanceService.isSummerThemeActive();
    }

    get isEasterThemeEnabled() {
        return this.AppearanceService.isEasterThemeActive();
    }

    get themesEnabled() {
        return (
            this.isSummerThemeEnabled || this.isChristmasThemeEnabled || this.isEasterThemeEnabled
        );
    }
}
</script>
